/* jp-nav.js — desktop mega-menu hover-intent + viewport clamp.
   Keyboard opens the panel via CSS :focus-within; JS mirrors aria-expanded
   for screen readers and adds the mouse open (120ms) / close (240ms) delay so the panel
   doesn't flicker on pass-through, and nudges wide panels inside the viewport
   via the --jp-mega-shift custom property. Esc closes any hover-opened panel.
   No jQuery / no frameworks. Guarded against double execution. */
(() => {
  if (window.__jpNavInit) return;
  window.__jpNavInit = true;

  const OPEN_DELAY = 120, CLOSE_DELAY = 240, MARGIN = 16;
  /* Touch/no-hover tablets (iPad / Surface in tablet mode) can't hover the parent link,
     so hover-open is skipped for them and replaced with the tap-to-open path below. */
  const noHover = () => window.matchMedia && window.matchMedia('(hover: none)').matches;

  const items = () => Array.prototype.slice
    .call(document.querySelectorAll('.jp-nav__item'))
    .filter((it) => it.querySelector('.jp-mega'));

  const syncItem = (it) => {
    const link = it.querySelector('.jp-nav__link');
    if (link) link.setAttribute('aria-expanded',
      (!it.classList.contains('is-escape-closed') && (it.classList.contains('is-open') || it.contains(document.activeElement))) ? 'true' : 'false');
  };
  const closeAll = (except) => items().forEach((it) => { if (it !== except) { it.classList.remove('is-open'); syncItem(it); } });

  /* mutual exclusion: opening a mega collapses the persona popover */
  const closePersona = () => document.querySelectorAll('[data-jp-persona].is-open').forEach((root) => {
    const menu = root.querySelector('.jp-persona__menu');
    const pill = root.querySelector('.jp-persona-pill');
    if (menu) menu.hidden = true;
    if (pill) pill.setAttribute('aria-expanded', 'false');
    root.classList.remove('is-open');
  });

  const clamp = (mega) => {
    if (!mega) return;
    mega.style.setProperty('--jp-mega-shift', '0px');
    const r = mega.getBoundingClientRect();
    let shift = 0;
    if (r.right > window.innerWidth - MARGIN) shift = (window.innerWidth - MARGIN) - r.right;
    else if (r.left < MARGIN) shift = MARGIN - r.left;
    if (shift) mega.style.setProperty('--jp-mega-shift', Math.round(shift) + 'px');
  };

  const bind = (item) => {
    if (item.__jpNavBound) return;
    item.__jpNavBound = true;
    const mega = item.querySelector('.jp-mega');
    let openT, closeT;
    item.addEventListener('mouseenter', () => {
      if (noHover()) return;
      window.clearTimeout(closeT);
      openT = window.setTimeout(() => { closeAll(item); closePersona(); clamp(mega); item.classList.add('is-open'); syncItem(item); }, OPEN_DELAY);
    });
    item.addEventListener('mouseleave', () => {
      if (noHover()) return;
      window.clearTimeout(openT);
      closeT = window.setTimeout(() => { item.classList.remove('is-open'); syncItem(item); }, CLOSE_DELAY);
    });
    /* keyboard: CSS :focus-within opens the panel — mirror that into aria-expanded */
    item.addEventListener('focusin', (e) => {
      if (!item.contains(e.relatedTarget)) item.classList.remove('is-escape-closed');
      clamp(mega); syncItem(item);
    });
    item.addEventListener('focusout', () => window.setTimeout(() => {
      if (!item.contains(document.activeElement)) item.classList.remove('is-escape-closed');
      syncItem(item);
    }, 0));
    /* Touch/no-hover: the parent link can't be hovered, so the FIRST tap opens the panel
       (making the mega children reachable) instead of navigating; a SECOND tap follows the link. */
    const link = item.querySelector('.jp-nav__link');
    if (link) link.addEventListener('click', (e) => {
      if (!noHover()) return;                          // pointer devices: navigate + hover, unchanged
      if (item.classList.contains('is-open')) return;  // second tap: let the link navigate
      e.preventDefault();
      closeAll(item); closePersona(); clamp(mega); item.classList.add('is-open'); syncItem(item);
    });
  };

  const boot = () => items().forEach(bind);

  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const activeItem = document.activeElement?.closest?.('.jp-nav__item');
    if (activeItem?.querySelector('.jp-mega')) {
      e.preventDefault();
      activeItem.classList.add('is-escape-closed');
      activeItem.classList.remove('is-open');
      const link = activeItem.querySelector('.jp-nav__link');
      if (link) { link.setAttribute('aria-expanded', 'false'); link.focus(); }
    }
    closeAll(activeItem || null);
  });
  /* Touch: a tap outside any open panel closes it (mouse relies on mouseleave). Runs after the
     parent-link handler above has set .is-open, so tapping the link to open never self-closes. */
  document.addEventListener('click', (e) => {
    if (noHover() && !e.target.closest('.jp-nav__item.is-open')) closeAll(null);
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
